<p>waiting-for-federated-auth works! <a class="underline" [routerLink]="['/']">Go back</a></p>
<p-progress-spinner class="self-center mt-8"/>
